<script>
    export let buildingColor;
    export let buildingBgColor;
    export let buildingHoverColor;
    export let popupBgColor;
    
    import { getContext, onMount } from "svelte";
    import { contextKey } from "@beyonk/svelte-mapbox";
    const { getMap, getMapbox } = getContext(contextKey);
    const map = getMap();
    const mapbox = getMapbox();

    let tooltipX = 0;
    let tooltipY = 0;
    let tooltipText;

    let tilesetUrl = 'mapbox://zdb-.ckqa4ou3004mx2dodni7p73hl-07433'
    let tilesetLayerName = 'davidsondavie_buildings'

    /*____________ Popups ____________*/
    import BuildingPopup from './BuildingPopup.svelte';
    import { fade, fly } from 'svelte/transition';
    const { open } = getContext('simple-modal');
    import {buildings} from './Buildings.js'
    const buildingPopups = buildings.filter((b)=> b.popup);
    
    // Options
    let popupOptions = {
        closeButton: true,
        closeOnEsc: true,
        closeOnOuterClick: true,
        transitionBg: fade,
        transitionBgProps: {
            duration: 250
        },
        transitionWindow: fly,
        transitionWindowProps: {
            y: window.innerHeight,
            duration: 1000
        },
        styleWindow: {  background: popupBgColor, color: '#fff',  },
        styleContent: { },
        styleCloseButton: { top: '-5px', right: '-5px' }
    };

    // Logs coordinates of click to console
    map.on("click", function(e){
        console.log(e.lngLat);
    });

    map.on("click", "tour-bg-buildings-layer", function(e){
        if(e.features && e.features[0] && e.features[0].properties){
            console.log(e.features[0].properties['@id']);
        }
    });

    // Click Event on Building
    map.on("click", "tour-buildings-layer", function (e) {
        if(!e.features){
            return;
        }
        let id = e.features[0].properties['@id'];
        let buildingPopup = buildingPopups.filter((popup)=>{
            return popup.id === id;
        })
        if(buildingPopup.length > 0){
            let popup = buildingPopup[0].popup;
            open(BuildingPopup, popup, popupOptions);
        } else {
            console.log(id);
            console.log(e.features[0].properties)
        }
    });

    /*____________ Color Tour Buildings ____________*/
    let tourIds = buildings.map((i)=>{ return i['id'] });
    
    let tourFeatures = [];
    let tourBgFeatures = [];

    map.addSource('base-buildings', {
        type: 'vector',
        url: tilesetUrl
    });

    map.addLayer({
        'id': 'tour-buildings-layer',
        'type': 'fill-extrusion',
        'source': 'base-buildings',
        'source-layer': tilesetLayerName,
        'paint': {
            'fill-extrusion-color': buildingColor,
            'fill-extrusion-height': 6,
        },
        'filter': ['in', ['get','@id'], ['literal', tourIds] ], 
    });

    map.addLayer({
        'id': 'tour-bg-buildings-layer',
        'type': 'fill-extrusion',
        'source': 'base-buildings',
        'source-layer': tilesetLayerName,
        'paint': {
            'fill-extrusion-color': buildingBgColor,
            'fill-extrusion-height': 6,
        },
        'filter': ['!', ['in', ['get','@id'], ['literal', tourIds] ] ], 
    });

    /*____________ Building Hover ____________*/
    

    // Buildings Hoverstate - Enter
    function buildingsMouseEnter(layer, color, hoverColor){
        return function(e){
            map.getCanvas().style.cursor = "pointer";
        
            tooltipX = e.point.x;
            tooltipY = e.point.y;

            let properties = e.features[0].properties
            let id = properties['@id'];

            map.setPaintProperty(
                layer, 
                "fill-extrusion-color", 
                ['match', ['get', '@id'], id, hoverColor, color]
            );

            let building = buildings.filter((b)=>{
                return b.id === id;
            })
            
            if(building.length > 0){
                building = building[0];
                tooltipText = building.title
            } else {
                tooltipText = properties['name']
            }
        }
    }

    // Buildings Hoverstate - Leave
    function buildingsMouseLeave(layer, color, hoverColor){
        return function(e){
            map.getCanvas().style.cursor = "";
            tooltipText = false;

            map.setPaintProperty(
                layer, 
                "fill-extrusion-color", 
                ['match', ['get', '@id'], 0, color, color]
            );
        }
    }

    map.on("mouseenter", "tour-buildings-layer", buildingsMouseEnter('tour-buildings-layer', buildingColor, buildingHoverColor));
    map.on("mouseleave", "tour-buildings-layer", buildingsMouseLeave('tour-buildings-layer', buildingColor, buildingHoverColor));
    map.on("mouseenter", "tour-bg-buildings-layer", buildingsMouseEnter('tour-bg-buildings-layer', buildingBgColor, buildingHoverColor));
    map.on("mouseleave", "tour-bg-buildings-layer", buildingsMouseLeave('tour-bg-buildings-layer', buildingBgColor, buildingHoverColor));

    setTimeout(() => {
        const mapFeatures = map
            .querySourceFeatures('base-buildings', { sourceLayer: tilesetLayerName })
            .map( (feature) => { return feature.properties })
        
        window.mapFeatures = mapFeatures;
        console.log(mapFeatures);

    }, 1000);
    

</script>

<style>
    .tooltip {
        position: absolute;
        background: #000;
        color: #fff;
        padding: 0.5rem;
        z-index: 999;
        border-radius: 15px;
    }
</style>

{#if tooltipText}
<div class="tooltip" style={` top: ${tooltipY-50}px; left: ${tooltipX-50}px;`}>{tooltipText}</div>
{/if}